document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.pawsip__gallery').forEach((gallery) => {
    const track = gallery.querySelector('.pawsip__gallery-track');
    const slides = [...track.querySelectorAll('figure')];
    const thumbs = [...gallery.querySelectorAll('[data-pawsip-thumb]')];
    const dialog = gallery.querySelector('.pawsip__lightbox');
    const dialogImage = dialog.querySelector('img');
    const close = dialog.querySelector('.pawsip__lightbox-close');
    const loadSlide = (index) => {
      const image = slides[index] && slides[index].querySelector('[data-pawsip-src]');
      if (image && !image.getAttribute('src')) image.src = image.dataset.pawsipSrc;
    };
    const setActive = (index) => thumbs.forEach((thumb, thumbIndex) => thumb.classList.toggle('is-active', thumbIndex === index));
    const showSlide = (index) => { loadSlide(index); slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }); setActive(index); };
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showSlide(index)));
    track.addEventListener('scroll', () => {
      const index = Math.round(track.scrollLeft / (slides[0].getBoundingClientRect().width + 8));
      const activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      loadSlide(activeIndex);
      setActive(activeIndex);
    }, { passive: true });
    gallery.querySelectorAll('[data-pawsip-image]').forEach((button) => button.addEventListener('click', () => {
      const image = button.querySelector('img'); dialogImage.src = image.currentSrc || image.src; dialogImage.alt = image.alt; dialog.showModal();
    }));
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  });

  // EasySell supplies an inline, !important CTA color. Apply Paw Sip blue when its form mounts.
  const styleEasySellButton = () => {
    document.querySelectorAll('#es-form-button, #es-popup-button, .es-popup-button-product, .es-popup-button-product button').forEach((button) => {
      button.style.setProperty('background', '#148bc9', 'important');
      button.style.setProperty('background-color', '#148bc9', 'important');
      button.style.setProperty('border-color', '#148bc9', 'important');
      button.style.setProperty('color', '#ffffff', 'important');
    });
  };

  // Keep the EasySell quantity card in step with the choice made on the Paw Sip page.
  // EasySell mounts its form after the CTA is clicked, so the matching card is selected once it appears.
  let pendingEasySellQuantity = null;
  const syncEasySellQuantityOffer = () => {
    if (!pendingEasySellQuantity) return;
    const expectedTitle = pendingEasySellQuantity === '2' ? '2 Paw Sips' : '1 Paw Sip';
    const target = [...document.querySelectorAll('.es-qo-container')].find((container) => {
      const title = container.querySelector('.offer-title');
      return title && title.textContent.trim() === expectedTitle;
    });
    if (!target) return;
    pendingEasySellQuantity = null;
    target.click();
  };

  // EasySell checks this selector when opening its COD form. It must point to the selected offer.
  window.ES_VARIANT_SELECTOR_OVERRIDE = '[data-pawsip-offer]:checked';
  styleEasySellButton();

  // The COD form is injected after this click. Retry briefly so its quantity cards
  // are available before applying the selection from the landing page.
  document.addEventListener('click', (event) => {
    if (!event.target.closest('#es-popup-button, .es-popup-button, .es-popup-button-product')) return;
    [120, 450, 900].forEach((delay) => window.setTimeout(() => {
      styleEasySellButton();
      syncEasySellQuantityOffer();
    }, delay));
  }, true);

  document.querySelectorAll('[data-pawsip-offer]').forEach((offer) => {
    offer.addEventListener('change', () => {
      if (!offer.checked) return;
      const form = offer.closest('form');
      const pricing = document.querySelector('[data-pawsip-pricing]');
      const quantityInput = form.querySelector('[data-pawsip-quantity]');
      if (quantityInput) quantityInput.value = offer.dataset.quantity || '1';
      pendingEasySellQuantity = offer.dataset.quantity || '1';
      form.querySelectorAll('.pawsip__offer-choice').forEach((choice) => choice.classList.toggle('is-selected', choice.contains(offer)));
      pricing.querySelector('[data-pawsip-current-price]').textContent = offer.dataset.price;
      pricing.querySelector('[data-pawsip-compare-price]').textContent = offer.dataset.comparePrice;
      pricing.querySelector('[data-pawsip-discount]').textContent = `Save ${offer.dataset.discount}%`;
      pricing.querySelector('[data-pawsip-saving-copy]').textContent = `You save ${offer.dataset.saving} today.`;
    });
  });

});
